module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_444444_256x240-a5ff0de92591e882b044dd6ed1570482.png";